import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { CustomerOrderOffersPage } from "src/components/views/erp/sales/customerOrderOffer/CustomerOrderOffersPage.tsx";
import { useKeptAliveView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/sales/offers")({
	staticData: { title: i18n.t("offers"), legacyViewKey: "customerOrderOffersPage" },
	component: RouteComponent,
});

function RouteComponent() {
	const { isActive } = useKeptAliveView();
	return <CustomerOrderOffersPage isActive={isActive} />;
}
